module.exports = __webpack_public_path__ + "devops.bi5MO6xI.svg";